import qs from 'qs';

export const buildMenuPath = locationSlug => {
  if (!locationSlug) {
    throw new Error('buildMenuPath requires locationSlug');
  }
  return `/${locationSlug}/menu`;
};

export const buildMenuItemPath = (locationSlug, menuItemSlug) => {
  if (!locationSlug) {
    throw new Error('buildMenuItemPath requires locationSlug');
  } else if (!menuItemSlug) {
    throw new Error('buildMenuItemPath requires menuItemSlug');
  }
  const menuPath = buildMenuPath(locationSlug);
  return `${menuPath}/${menuItemSlug}`;
};

export const buildMenuItemUpsellPath = (locationSlug, menuItemSlug) => {
  if (!locationSlug) {
    throw new Error('buildMenuItemUpsellPath requires locationSlug');
  } else if (!menuItemSlug) {
    throw new Error('buildMenuItemUpsellPath requires menuItemSlug');
  }
  const menuPath = buildMenuPath(locationSlug);
  return `${menuPath}/upsell/${menuItemSlug}`;
};

export const buildOrderSettingsPath = ({
  locationSlug,
  fulfillmentMethod = null,
  minFulfillmentDateTime = null,
  shipping_city = null,
  shipping_state = null,
  shipping_postal_code = null,
  shipping_google_place_id = null,
  shipping_street_address_1 = null,
  shipping_country = null,
  shipping_lat = null,
  shipping_lng = null
}) => {
  if (!locationSlug) {
    throw new Error('buildOrderSettingsPath requires locationSlug');
  }
  const menuPath = buildMenuPath(locationSlug);
  let path = `${menuPath}/order-settings`;

  if (fulfillmentMethod) {
    const queryStringForFulfillmentMethod = qs.stringify({
      fulfillmentMethod: fulfillmentMethod
    });
    path += `?${queryStringForFulfillmentMethod}`;

    if (minFulfillmentDateTime) {
      const queryStringForMinFulfillmentDateTime = qs.stringify({
        minFulfillmentDateTime: minFulfillmentDateTime
      });
      path += `&${queryStringForMinFulfillmentDateTime}`;
    }

    if (
      shipping_street_address_1 &&
      shipping_city &&
      shipping_state &&
      shipping_postal_code &&
      shipping_country &&
      shipping_google_place_id &&
      shipping_lat &&
      shipping_lng
    ) {
      const queryStringForUserAddress = qs.stringify({
        shipping_street_address_1: shipping_street_address_1,
        shipping_city: shipping_city,
        shipping_state: shipping_state,
        shipping_postal_code: shipping_postal_code,
        shipping_country: shipping_country,
        shipping_lat: shipping_lat,
        shipping_lng: shipping_lng,
        shipping_google_place_id: shipping_google_place_id
      });

      path += `&${queryStringForUserAddress}`;
    }
  }

  return path;
};

export const buildCartPath = locationSlug => {
  if (!locationSlug) {
    throw new Error('buildCartPath requires locationSlug');
  }
  const menuPath = buildMenuPath(locationSlug);
  return `${menuPath}/cart`;
};

export const buildCartItemPath = (locationSlug, cartItemId) => {
  if (!locationSlug) {
    throw new Error('buildCartItemPath requires locationSlug');
  } else if (!cartItemId) {
    throw new Error('buildCartItemPath requires cartItemId');
  }
  const cartPath = buildCartPath(locationSlug);
  return `${cartPath}/${cartItemId}`;
};
